import { Component, Input, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'edit-add-node-dialog',
    templateUrl: './edit-node-dialog.component.html',
    styleUrls: ['./edit-node-dialog.component.scss'],
    standalone: false
})
export class EditNodeDialogComponent implements OnInit {
    @Input() public newNodeName: string = '';
    @Input() public isTopic: boolean;
    @Input() public isSensitive: boolean;
    @Input() public storageTime: number;
    @Input() public recordingPermission: boolean;
    @Input() public hasUnleashAccess: boolean;

    public isStorageTimeValid: boolean = true;
    public errorMessage: string = "The value must be between 5 and 3650";
    public tooltip: string = "If you enter a value here and the agent selects this topic for a call that's recorded, the call recording will be stored in Archive for the number of days defined here, instead of for the number of days configured in the Archive";

    constructor(
        public dialogRef: MatDialogRef<EditNodeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit(): void {
        this.newNodeName = this.data.description;
        this.isTopic = this.data.isTopic;
        this.isSensitive = this.data.isSensitive;
        this.storageTime = this.data.storageTime;
        this.recordingPermission = this.data.recordingPermission;
        this.hasUnleashAccess = this.data.hasUnleashAccess;
    }

    sensitiveState(ev) {
        this.isSensitive = ev.checked;
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    editNode(): void {
        this.dialogRef.close({ description: this.newNodeName, isSensitive: this.isSensitive, storageTime: this.storageTime ? this.storageTime : null });
    }

    getTooltip() {
        return "If a topic is marked as \"Sensitive\" and an agent makes an Enquiry registration containing this topic, the call recording this registration belongs to will be flagged as \"Sensitive\" in the Archive.";
    }

    isStorageTimeFieldVisible() {
        if (!this.hasUnleashAccess) return false;
        if (!this.storageTime && !this.recordingPermission) return false;
        else return true;
    }

    isStorageTimeFieldDisabled() {
        if (this.storageTime && !this.recordingPermission) return true;
        else return false;
    }

    onStorageTimeValidityChange(isValid: boolean) {
        this.isStorageTimeValid = isValid;
    }

    isApplyDisabled() {
        let isDisabled = false;
        if (this.newNodeName.length === 0) isDisabled = true;
        if (!this.isStorageTimeValid) isDisabled = true;

        return isDisabled;
    }
}